import React from 'react';
import heroImage from '../Assets/img/fa1.png';
import facilityImage from '../Assets/Images/Subtract.png'; // Make sure this image exists in your project
import personnel1 from '../Assets/Images/personel.png';
import personnel2 from '../Assets/Images/behind.png';
import personnel3 from '../Assets/Images/the.png';
import personnel4 from '../Assets/Images/success.png';
import { MdMargin } from 'react-icons/md';

const Capabilities = () => {
  return (
    <>
      {/* HERO SECTION */}
      <div className="page-template page-template-elementor_header_footer page page-id-1050 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1050">
        <div id="page" className="jkit-template site">
          <div data-elementor-type="wp-page" data-elementor-id="1050" className="elementor elementor-1050">
            {/* Hero Image */}
            <div
              className="elementor-element elementor-element-bdbb4a9 e-flex e-con-boxed e-con e-parent"
              data-id="bdbb4a9"
              style={{ height: '700px', position: 'relative', overflow: 'hidden' }}
            >
              <img src={heroImage} alt="Hero Cover" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
            </div>

            {/* OUR FACILITY */}
            <div className="elementor-element e-flex e-con-boxed e-con e-parent" style={{ padding: '80px 0' }}>
              <div className="e-con-inner" style={{ textAlign: 'center' }}>
                <h2 style={{ fontSize: '48px', fontWeight: '600', marginTop:'70px' }}>Our Facility</h2>
                <p style={{ color: '#607084', marginTop: '10px', fontSize: '18px' }}>
                  Where precision engineering and quality craftsmanship drive our production excellence
                </p>

                {/* Facility Stats */}
               {/* Facility Stats */}
<div style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '1200px',
  margin: '40px auto 0',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  borderRadius: '12px',
  overflow: 'hidden',
  backgroundColor: '#fff'
}}>
  {/* Item 1 */}
  <div style={{ flex: 1, padding: '30px' }}>
    <h3 style={{ color: '#025099', marginBottom: '8px', fontSize:'32px' }}>23400+ sq ft</h3>
    <p style={{ margin: 0, color:'#666666' }}>State of Art Facility</p>
  </div>

  {/* Separator */}
  <div style={{ width: '1px', height: '80px', backgroundColor: '#d3d3d3' }} />

  {/* Item 2 */}
  <div style={{ flex: 1, padding: '30px' }}>
    <h3 style={{ color: '#025099', marginBottom: '8px', fontSize:'32px' }}>10600+ sq ft</h3>
    <p style={{ margin: 0, color:'#666666' }}>Manufacturing Area</p>
  </div>

  {/* Separator */}
  <div style={{ width: '1px', height: '80px', backgroundColor: '#d3d3d3' }} />

  {/* Item 3 */}
  <div style={{ flex: 1, padding: '30px' }}>
    <h3 style={{ color: '#025099', marginBottom: '8px', fontSize:'32px' }}>30+</h3>
    <p style={{ margin: 0, color:'#666666' }}>Workforce</p>
  </div>
</div>


                {/* Facility Image */}
                <div style={{ marginTop: '50px', width:'90%', margin:'0 auto' }}>
                  <img src={facilityImage} alt="Facility" style={{ width: '100%', maxHeight: '600px', objectFit: '', marginTop:'60px' }} />
                </div>
              </div>
            </div>

            {/* HHG PERSONNEL */}
            {/* HHG PERSONNEL */}
<div className="elementor-element e-flex e-con-boxed e-con e-parent" style={{ padding: '80px 0', backgroundColor: '#f9f9f9' }}>
  <div className="e-con-inner" style={{ textAlign: 'center' }}>
    <h2 style={{ fontSize: '64px', fontWeight: '500', marginBottom: '65px', marginTop: '65px', color: '#004E98' }}>
      HHG Personnel Behind the Success
    </h2>

    <div style={{
      position: 'relative',
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
    }}>
      {[
        { img: personnel1, title: "Expertise in DFM Engineering." },
        { img: personnel2, title: "Designers specializing in advanced 3D modeling and simulation." },
        { img: personnel3, title: "Project Engineers ensuring on-time delivery and project success." },
        { img: personnel4, title: "Control Engineers focused on precision automation systems." }
      ].map((item, index) => (
        <div
          key={index}
          style={{
            textAlign: 'center',
            position: 'relative',
            marginTop: index % 2 === 0 ? '-120px' : '250px', // zigzag layout
            zIndex: 2,
          }}
        >
          <div style={{
            width: '235px',
            height: '235px',
            borderRadius: '50%',
            overflow: 'hidden',
            margin: '0 auto',

            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}>
            <img src={item.img} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <p style={{ marginTop: '15px', fontSize: '16px', color: '#025099', width: '250px', marginBottom: '65px' }}>{item.title}</p>
        </div>
      ))}

     {/* CURVED DOTTED LINES */}
<svg width="100%" height="320" style={{ position: 'absolute', top: '120px', left: '0', zIndex: 1 }}>
  <defs>
    <style>{`.dotted-line { fill: none; stroke: #999; stroke-width: 2; stroke-dasharray: 6,6; }`}</style>
  </defs>

  {/* Curve between image 1 and 2 */}
  <path
    className="dotted-line"
    d="M150,100 Q270,180 390,190"
  />

  {/* Curve between image 2 and 3 */}
  <path
    className="dotted-line"
    d="M510,190 Q640,60 770,100"
  />

  {/* Curve between image 3 and 4 */}
  <path
    className="dotted-line"
    d="M880,100 Q1010,220 1130,180"
  />
</svg>

    </div>
  </div>
</div>


          </div>
        </div>
      </div>

<style>{`
  @media (max-width: 768px) {
    /* Hero image */
    .elementor-element-bdbb4a9 {
      height: 300px !important;
    }

    .elementor-element-bdbb4a9 img {
      object-fit: cover !important;
    }

    /* Facility heading */
    .e-con-inner h2 {
      font-size: 28px !important;
    }

    .e-con-inner p {
      font-size: 16px !important;
      padding: 0 10px;
    }

    /* Facility stats */
    .e-con-inner > div[style*="display: flex"] {
      flex-direction: column !important;
      box-shadow: none !important;
      gap: 15px;
    }

    .e-con-inner > div[style*="display: flex"] > div {
      border-bottom: 1px solid #ddd;
      width: 100% !important;
      text-align: center;
      padding: 20px 0 !important;
    }

    .e-con-inner > div[style*="display: flex"] > div:last-child {
      border-bottom: none;
    }

    .e-con-inner > div[style*="display: flex"] > div[style*="width: 1px"] {
      display: none !important;
    }

    /* Facility image */
    .e-con-inner img {
      width: 100% !important;
      height: auto !important;
      max-height: 400px !important;
    }

    /* HHG Personnel */
    .e-con-inner > div[style*="display: flex"][style*="wrap"] {
      flex-direction: column !important;
      align-items: center !important;
    }

    .e-con-inner > div[style*="display: flex"][style*="wrap"] > div {
      margin-top: 30px !important;
    }

    .e-con-inner > div[style*="display: flex"][style*="wrap"] p {
      width: 90% !important;
      font-size: 14px !important;
    }

    /* Hide dotted lines */
    svg {
      display: none !important;
    }
  }
`}</style>


    </>
  );
};

export default Capabilities;
